import React from 'react'
import WhyACComponent from '../components/WhyACComponent'

const WhyAC = () => {
  return (
    <div>
<WhyACComponent/>
    </div>
  )
}

export default WhyAC